import { render, staticRenderFns } from "./xitongguanli.vue?vue&type=template&id=67fb48b4&"
import script from "./xitongguanli.vue?vue&type=script&lang=js&"
export * from "./xitongguanli.vue?vue&type=script&lang=js&"
import style0 from "./xitongguanli.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports